import {
  getDateRanges,
  getRangeOptions,
  getRangeOptionsWithCustom
} from "../../utils/date-range-options";

export const getInitialRangeOptions = (startDate, endDate, theBeginningOfTime) => {
  // add custom range as the last range option in range options array
  const rangeOptions = getRangeOptions(endDate, theBeginningOfTime);
  return getRangeOptionsWithCustom(rangeOptions, { payload: { startDate, endDate } }).map(
    (option) => ({
      ...option,
      // add start and end dates to the each range options object
      ...getDateRanges(
        endDate, // calendar_end_date
        { name: option.name, startDate, endDate },
        theBeginningOfTime //state.currentUser.theBeginningOfTime
      )
    })
  );
};
